/**
 *
 * NotificationContainer
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import makeSelectNotificationContainer, {
  MakeSelectCount,
  MakeSelectNotifications,
  MakeSelectTotal,
  MakeSelectIsLoading,
} from "./selectors"
import reducer from "./reducer"
import saga from "./saga"

import NotificationBadge from "../../components/NotificationBadge/index.js"
import {
  updateBadge,
  fetchNotifications,
  goToNotification,
  setAllRead,
  setCount,
} from "./actions"

export class NotificationContainer extends React.Component {
  componentDidMount() {
    this.props.fetchNotifications(1)
  }

  render() {
    return (
      <NotificationBadge
        {...this.props}
        setCount={(t) => this.props.setCount(t)}
      />
    )
  }
}

NotificationContainer.propTypes = { dispatch: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  notificationContainer: makeSelectNotificationContainer(),
  count: MakeSelectCount(),
  notifications: MakeSelectNotifications(),
  total: MakeSelectTotal(),
  isLoading: MakeSelectIsLoading(),
})

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    updateBadge: (payload) => dispatch(updateBadge(payload)),
    fetchNotifications: (payload) => dispatch(fetchNotifications(payload)),
    goToNotification: (payload) => dispatch(goToNotification(payload)),
    setAllRead: (_) => dispatch(setAllRead()),
    setCount: (payload) => dispatch(setCount(payload)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "notificationContainer", reducer })
const withSaga = injectSaga({ key: "notificationContainer", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(NotificationContainer)
